import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsFinanceByRoles(companyId, query) {
  return dataTransferWrap(
    ModulesMap.REPORTS_FINANCE_BY_ROLES,dtConfig[ModulesMap.REPORTS_FINANCE_BY_ROLES].getReportsFinanceByRoles,
    {
      urlParams: {
        companyId: companyId,
      },
      params: query,
    },
  )
}

export default {
  getReportsFinanceByRoles
}